import { render, staticRenderFns } from "./ClearIcon.vue?vue&type=template&id=44d24766&"
import script from "./ClearIcon.vue?vue&type=script&lang=js&"
export * from "./ClearIcon.vue?vue&type=script&lang=js&"
import style0 from "./ClearIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports